import { Button } from "@material-tailwind/react";
import React from "react";

export default function Pagination({
  totalItemsCount,
  currentPage,
  lastPage,
  perPageCount,
  onBtnClick,
  dark = false,
}) {
  const onNextClick = () => onBtnClick(currentPage + 1);
  const onPreviousClick = () => onBtnClick(currentPage - 1);
  const previousDisabled = currentPage <= 1;
  const nextDisabled = currentPage === lastPage;
  return (
    <div className="w-full flex flex-col justify-center items-center py-6 mt-4">
      <div className={`inline-flex items-center gap-2 p-1.5 rounded-2xl border backdrop-blur-md shadow-lg ${
        dark ? "bg-zinc-900/80 border-zinc-800 shadow-black/40" : "bg-white border-gray-200 shadow-gray-200/50"
      }`}>
        {/* Previous Page Button */}
        <button
          onClick={onPreviousClick}
          disabled={previousDisabled}
          aria-label="Previous Page"
          className={`inline-flex h-10 px-3 sm:px-4 items-center gap-1.5 rounded-xl font-bold text-xs transition-all active:scale-95 ${
            previousDisabled
              ? "opacity-35 cursor-not-allowed text-zinc-500"
              : "bg-secondary text-white hover:bg-secondary/90 shadow-md shadow-secondary/25"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
          <span className="hidden sm:inline">Prev</span>
        </button>

        {/* Page Status Pill */}
        <div className={`px-4 py-1.5 rounded-xl text-xs font-black flex items-center gap-1.5 ${
          dark ? "bg-zinc-950/70 text-zinc-300" : "bg-gray-100 text-gray-800"
        }`}>
          <span>Page</span>
          <span className="text-secondary font-black text-sm">{currentPage}</span>
          <span className="text-zinc-500">/</span>
          <span>{lastPage || 1}</span>
        </div>

        {/* Next Page Button */}
        <button
          onClick={onNextClick}
          disabled={nextDisabled}
          aria-label="Next Page"
          className={`inline-flex h-10 px-3 sm:px-4 items-center gap-1.5 rounded-xl font-bold text-xs transition-all active:scale-95 ${
            nextDisabled
              ? "opacity-35 cursor-not-allowed text-zinc-500"
              : "bg-secondary text-white hover:bg-secondary/90 shadow-md shadow-secondary/25"
          }`}
        >
          <span className="hidden sm:inline">Next</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
